export default function wishlistToggleEmailForm() {
  const toggleBtn = document.querySelector('#wishlistToggleButton');
  const formWrapper = document.querySelector('#wishlistShareEmailList');

  if (!toggleBtn || !formWrapper) {
    return;
  }

  let isFormActive = false;

  toggleBtn.addEventListener('click', () => {
    isFormActive = !isFormActive;
    toggleBtn.classList[isFormActive ? 'add' : 'remove']('active');
    formWrapper.classList[isFormActive ? 'remove' : 'add']('hidden');

    // Toggle animation after `hidden` class applied
    setTimeout(() => {
      formWrapper.classList[isFormActive ? 'add' : 'remove']('animate');
    }, 0);
  });
}
